import { authenticatedFetch } from './authenticatedFetch';

/**
 * DOCTOR CONSENT API - Fetch and submit doctor consent (doctors_consent table).
 * Used only for logged-in doctors: Platform Terms + Clinical Acknowledgment.
 */

export interface DoctorConsentStatus {
  hasConsent: boolean;
  doc_id: number | null;
  terms_accepted?: boolean;
  clinical_acknowledged?: boolean;
  accepted_at?: string;
}

export async function getDoctorConsent(email: string): Promise<DoctorConsentStatus> {
  const q = new URLSearchParams({ email });
  const response = await authenticatedFetch(`/api/doctors/consent?${q.toString()}`);
  if (!response.ok) throw new Error(await response.text().then(t => t || 'Request failed'));
  return response.json();
}

export async function submitDoctorConsent(email: string): Promise<{ success: boolean; doc_id: number }> {
  const response = await authenticatedFetch('/api/doctors/consent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      terms_accepted: true,
      clinical_acknowledged: true,
    }),
  });
  if (!response.ok) throw new Error(await response.text().then(t => t || 'Request failed'));
  return response.json();
}
